<template>
  <v-container class="pa-0">

    <v-card class="pa-3">
      <div class="title pl-1 mb-5 grey--text">
        Create Decks
      </div>
      <v-layout row wrap>
        <v-flex class="px-2" xs10>
          <v-select v-model="selectedDeck" :items="decks" item-text="name" item-value="id" label="Select Deck" solo></v-select>
        </v-flex>
        <v-flex xs2>
          <v-btn icon large @click="deckDialog = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>

        </v-flex>

      </v-layout>

      <v-row>
        <div class="pa-5" v-if="deckDetails" @click="toggleDeckPublicView(deckDetails.public)">
          Public: {{deckDetails.public}}
        </div>

      </v-row>

    </div>

      <v-btn icon large color="orange" @click="createNewCard" v-if="selectedDeck.length > 0">
        <v-icon>mdi-plus-box-multiple</v-icon>
      </v-btn>
      <v-layout row wrap v-for="card in cards" class="pa-3">
        <v-flex v-html="card.question" class="pa-2 blue--text" xs6 md3></v-flex>
        <v-flex class="pa-2" xs6 md3><img width="100%" :src='card.question_image'></v-flex>
        <v-flex v-html="card.answer" class="pa-2" xs6 md3></v-flex>
        <v-flex class="pa-2 text-right" xs6 md3>
          <v-btn small icon @click="editCard(card)"><v-icon>mdi-pencil-outline</v-icon></v-btn>
          <img width="100%" :src='card.answer_image'>
        </v-flex>

      </v-layout>


      <p {{card}}</p>
    </v-card>





    <v-dialog v-model="dialog" max-width="700">
      <v-card class="pa-3">
        <v-form>
          <div>Add Card</div>
          <div class="grey--text">Question</div>
          <vue-editor id="editor1" v-model="newCard.question" :editorToolbar="customToolbar"></vue-editor>
          <imageUpload ref="questionImage" @downloadURL="questionImageUpload"/>
          <div class="grey--text">Answer</div>
          <vue-editor id="editor2" v-model="newCard.answer" :editorToolbar="customToolbar"></vue-editor>
          <imageUpload ref="answerImage" @downloadURL="answerImageUpload"/>
          <v-btn v-if="!edit"  class="mt-5" @click="saveCard">Save</v-btn>
          <v-btn v-if="edit" color="orange" dark class="mt-5" @click="updateCard">Update</v-btn>

          <v-btn absolute right icon v-if="edit" @click="deleteCard">
            <v-icon color="grey darken-1">mdi-delete</v-icon>
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deckDialog" max-width="400">
      <v-card class="pa-3">
        <v-form>
          <div>Add Deck</div>
          <v-text-field label="Deck Name" v-model="newDeck.name"></v-text-field>
          <v-text-field label="Subject" v-model="newDeck.subject"></v-text-field>
          <v-btn @click="saveDeck">Save Deck</v-btn>

        </v-form>
      </v-card>
    </v-dialog>


  </v-container>



</template>

<script>
import obj from '@/objects'
import db from '@/fb'
import firebase from 'firebase'
import imageUpload from '@/components/imageUpload'
import { VueEditor } from "vue2-editor";

export default {
  name: 'Create',
  components: {
    imageUpload,
    VueEditor
  },
  data() {
    return {
      customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }]],
      dialog: false,
      deckDialog: false,
      selectedDeck: '',
      deckDetails: null,
      newDeck: obj.createNewDeck(),
      newCard: obj.createNewCard('question_answer'),
      cards: [],
      decks: [],
      edit: false,
    }
  },
  watch: {
    selectedDeck() {
      this.getData(this.selectedDeck)
      this.getDeckDetails(this.selectedDeck)
    }
  },
  methods: {
    questionImageUpload(url) {
      this.newCard.question_image = url
      console.log(url)
    },
    answerImageUpload(url) {
      this.newCard.answer_image = url
      console.log(url)
    },
    createNewCard() {
      this.newCard = obj.createNewCard('question_answer')
      this.dialog = true
      this.edit = false
    },
    saveCard() {
      let copy = Object.assign({}, this.newCard);
      copy.deck = this.selectedDeck

      firebase.firestore().collection('cards').doc().set(copy)
      this.newCard = obj.createNewCard('question_answer')
      this.dialog = false
      this.$refs.answerImage.resetComponent()
      this.$refs.questionImage.resetComponent()
      this.getData(this.selectedDeck)

    },
    editCard(card) {
      this.newCard = card
      this.dialog = true
      this.edit = true
    },
    updateCard() {
      let copy = Object.assign({}, this.newCard);
      delete copy.id
      firebase.firestore().collection('cards').doc(this.newCard.id).update(copy).then(result => {
        this.newCard = obj.createNewCard('question_answer')
        this.dialog = false
        this.edit = false
      })

    },
    deleteCard() {
      confirm("Delete this card?")
      firebase.firestore().collection('cards').doc(this.newCard.id).delete().then(result => {
        this.newCard = obj.createNewCard('question_answer')
        this.dialog = false
        this.edit = false
        this.getData(this.selectedDeck)
      })
    },
    saveDeck() {
      firebase.firestore().collection('decks').doc().set(this.newDeck)
      this.newDeck = obj.createNewDeck()
      this.deckDialog = false
      this.getDecks()
    },

    getData(deckId) {
      this.cards = []
      firebase.firestore().collection('cards').where('deck', '==', deckId).orderBy('created', 'desc').get().then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          this.cards.push(item)
        })
      })
    },
    getDeckDetails() {

      firebase.firestore().collection('decks').doc(this.selectedDeck).get().then(result => {
        this.deckDetails = result.data()
      })

    },
    toggleDeckPublicView(state) {
      this.deckDetails.public = !state
      firebase.firestore().collection('decks').doc(this.selectedDeck).update({
        public: !state
      })
    },
    getDecks() {
      this.decks = []
      firebase.firestore().collection('decks').where('uid', '==', firebase.auth().currentUser.uid).get().then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          this.decks.push(item)
        })
      })
    },



  },
  mounted() {
    this.getData(this.selectedDeck)
    this.getDecks()
  }
};
</script>

<style>
#editor1 {
  height: 100px;
}
#editor2 {
  height: 200px;
}

.ql-indent-1 {
  margin-left: 1em;
}
.ql-indent-2 {
  margin-left: 2em;
}
.ql-indent-3 {
  margin-left: 3em;
}
.ql-indent-4 {
  margin-left: 4em;
}

</style>
